import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Trans, t } from "@lingui/macro";

import { i18n } from "base/i18n";
import { Modal } from "widgets/modal";
import { Button, BUTTON_TYPES, MultiLine, FieldErrors } from "widgets/inputs";
import { Validation, Validator, ValidateHelper } from "widgets/validation";

import styles from "./reject.css";

export function Reject({ closeRejectModal, onBulkReject }) {
  let [comments, setComments] = useState(null);
  let [error, setError] = useState({});
  // let [disabled, setDisabled] = useState(false);
  const validationRef = useRef(null);

  function handleReject() {
    // setDisabled(true);
    let err = validationRef.current && validationRef.current.validate();
    if (err && err.comments) {
      onValidate(err);
    } else {
      onBulkReject(comments);
      closeRejectModal();
    }
  }

  function onValidate(newErr) {
    let newError = { ...error, ...newErr };
    setError(newError);
  }

  return (
    <Modal
      titleRenderer={() => <Trans>Reject</Trans>}
      rightActionsRenderer={() => (
        <div className={styles.buttonActionStyle}>
          <Button type={BUTTON_TYPES.SECONDARY} onClick={closeRejectModal}>
            <Trans>Cancel</Trans>
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={() => handleReject()}
            // disabled={disabled || !comments}
          >
            <Trans>Reject</Trans>
          </Button>
        </div>
      )}
      open={true}
      onClose={closeRejectModal}
      bodyStyle={{
        backgroundColor: "var(--white)",
        padding:
          "var(--space-16) var(--space-20) var(--space-20) var(--space-20)"
      }}
      className={styles.formModalStyle}
      width="52rem"
    >
      <div className={styles.rejectContent}>
        <Validation ref={validationRef}>
          <Validator
            name="comments"
            value={comments}
            onValidate={onValidate}
            validations={[ValidateHelper.required]}
          >
            <MultiLine
              label={i18n._(t`Notes`)}
              required={true}
              autoGrow={false}
              value={comments}
              name="comments"
              onChange={(e) => setComments(e.target.value)}
              showCharacterLimitHint={true}
            />
          </Validator>
        </Validation>
        {error && error.comments && (
          <FieldErrors
            errors={[<Trans key="noteError">Note is required</Trans>]}
          />
        )}
      </div>
    </Modal>
  );
}
Reject.propTypes = {
  onBulkReject: PropTypes.func,
  closeRejectModal: PropTypes.func
};
